import { Stage } from 'konva/lib/Stage';
import React, {
  createRef, useContext, createContext, Ref,
} from 'react';

const playerStageRef = createRef<Stage>();

export const PlayerStageContext = createContext<Ref<Stage> | null>(null);
export const usePlayerStageContext = () => useContext(PlayerStageContext);

export const VideoContextProvider: React.FC = (props) => {
  const { children } = props;

  return (
    <PlayerStageContext.Provider value={playerStageRef}>
      {children}
    </PlayerStageContext.Provider>
  );
};
